import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const listProjects = (page = 1, limit = 10, search = "") => {
  const body = { page, limit };
  if (search) body.search = search;
  return axios.post(`${BASE}/api/v1/projects/list`, body, { headers: authHeaders() });
};

// Unpaginated projectPid + projectName only — for filter dropdowns (super_admin only).
export const listProjectsLite = () =>
  axios.get(`${BASE}/api/v1/projects/lite-list`, { headers: authHeaders() });

export const getProjectStats = () =>
  axios.post(`${BASE}/api/v1/projects/stat`, {}, { headers: authHeaders() });

// Super admin dashboard aggregate stats — true global counts (not derived from a
// paginated /projects/list page) plus the 5 most recently created projects.
export const getSuperAdminDashboardStats = () =>
  axios.post(`${BASE}/api/v1/dashboard/super-admin/stat`, {}, { headers: authHeaders() });

export const getProject = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/get`, { projectPid }, { headers: authHeaders() });

export const createProject = ({ projectName, description, websiteUrl }) => {
  const body = { projectName };
  if (description) body.description = description;
  if (websiteUrl) body.websiteUrl = websiteUrl;
  return axios.post(`${BASE}/api/v1/projects/create`, body, { headers: authHeaders() });
};

export const updateProject = (projectPid, projectName) =>
  axios.put(`${BASE}/api/v1/projects/update`, { projectPid, projectName }, { headers: authHeaders() });

export const updateProjectStatus = (projectPid, isActive) =>
  axios.put(`${BASE}/api/v1/projects/update`, { projectPid, isActive: isActive ? 1 : 0 }, { headers: authHeaders() });

// ── Funds ─────────────────────────────────────────────────────

export const getFund = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/funds/get`, { projectPid }, { headers: authHeaders() });

export const getFundStat = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/funds/stat`, { projectPid }, { headers: authHeaders() });

export const addFund = (projectPid, amount, note = "") =>
  axios.post(`${BASE}/api/v1/projects/funds/add`, { projectPid, amount, note }, { headers: authHeaders() });

export const getFundTransactions = (projectPid, page = 1, limit = 20) =>
  axios.post(`${BASE}/api/v1/projects/funds/transactions`, { projectPid, page, limit }, { headers: authHeaders() });

export const deleteProject = (projectPid) =>
  axios.delete(`${BASE}/api/v1/projects/delete`, {
    headers: authHeaders(),
    data: { projectPid },
  });

// ── Managers

export const searchUsers = (query) =>
  axios.post(`${BASE}/api/v1/users/search`, { query }, { headers: authHeaders() });

export const listManagers = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/managers/list`, { projectPid }, { headers: authHeaders() });

export const listAllManagers = () =>
  axios.post(`${BASE}/api/v1/projects/managers/list`, {}, { headers: authHeaders() });

export const assignManager = (projectPid, payload) =>
  axios.post(`${BASE}/api/v1/projects/managers/assign`, { projectPid, ...payload }, { headers: authHeaders() });

export const removeManager = (projectPid, userPid) =>
  axios.delete(`${BASE}/api/v1/projects/managers/remove`, {
    headers: authHeaders(),
    data: { projectPid, userPid },
  });

// ── Public Widget Credential & Domain Whitelist

export const getPublicCredential = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/public-credential/get`, { projectPid }, { headers: authHeaders() });

export const regeneratePublicCredential = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/public-credential/regenerate`, { projectPid }, { headers: authHeaders() });

export const listPublicDomains = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/public-credential/domains/list`, { projectPid }, { headers: authHeaders() });

export const addPublicDomain = (projectPid, domain) =>
  axios.post(`${BASE}/api/v1/projects/public-credential/domains/add`, { projectPid, domain }, { headers: authHeaders() });

export const removePublicDomain = (projectPid, domainId) =>
  axios.delete(`${BASE}/api/v1/projects/public-credential/domains/remove`, {
    headers: authHeaders(),
    data: { projectPid, domainId },
  });

// ── API Keys

export const listApiKeys = (projectPid) =>
  axios.post(`${BASE}/api/v1/projects/keys/list`, { projectPid }, { headers: authHeaders() });

export const createApiKey = (projectPid, keyName, expiresAt = null) =>
  axios.post(`${BASE}/api/v1/projects/keys/create`, { projectPid, keyName, expiresAt }, { headers: authHeaders() });

export const revokeApiKey = (projectPid, keyPid) =>
  axios.delete(`${BASE}/api/v1/projects/keys/delete`, {
    headers: authHeaders(),
    data: { projectPid, keyPid },
  });
